import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerAndAddressCardComponent } from './customer-and-address-card.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [CustomerAndAddressCardComponent],
  exports: [CustomerAndAddressCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ]
})
export class CustomerAndAddressCardModule { }
